// extracted by mini-css-extract-plugin
export var cardIcon = "_4x-4";
export var checkboxCard = "_4x-0";
export var checkboxCardSelected = "_4x-1";
export var disabled = "_4x-2";
export var outerBorder = "_4x-3";
export var spacerMedium = "_4x-7";
export var spacerSmall = "_4x-6";
export var spacerXsmall = "_4x-5";